import { Link, matchPath, useLocation } from "react-router-dom";
import logo from "../../assets/images/logo-text.png";
import { useEffect, useState } from "react";
import { useApplicationContext } from "../../context/ApplicationContext";
import { usePermission } from "../../hooks/usePermission";

const Sidebar = () => {
  const { user } = useApplicationContext();
  const { hasPermission } = usePermission();

  const closeDrawer = () => {
    let html = document.querySelector("html");
    html.classList.remove("layout-menu-expanded");
  };

  const isSuperAdmin = user?.user_type === 1 ? 1 : 0;
  const isCountryAdmin = user?.user_type === 6 ? 1 : 0;
  const isStateAdmin = user?.user_type === 7 ? 1 : 0;
  const isRegionAdmin = user?.user_type === 2 ? 1 : 0;
  const isChapterAdmin = user?.user_type === 3 ? 1 : 0;

  const location = useLocation();
  const isParentPath = (url) => matchPath(url, location.pathname) != null;

  const [showMastersSubMenu, setShowMastersSubMenu] = useState(false);
  const [showReportsSubMenu, setShowReportsSubMenu] = useState(false);
  const [showVisitorsSubMenu, setShowVisitorsSubMenu] = useState(false);

  const dashboardRoute = () =>
    isParentPath("/") || isParentPath("/home") || isParentPath("/dashboard");

  const userRoutes = () =>
    isParentPath("/users") ||
    isParentPath("/user/create") ||
    isParentPath("/user/:id/edit");

  const regionRoutes = () =>
    isParentPath("/regions") ||
    isParentPath("/create/region") ||
    isParentPath("/region/:id/edit");

  const countryRoutes = () =>
    isParentPath("/countries") ||
    isParentPath("/create/country") ||
    isParentPath("/country/:id/edit");

  const stateRoutes = () =>
    isParentPath("/states") ||
    isParentPath("/create/state") ||
    isParentPath("/state/:id/edit");

  const cityRoutes = () =>
    isParentPath("/citys") ||
    isParentPath("/create/city") ||
    isParentPath("/city/:id/edit");

  const chapterRoutes = () =>
    isParentPath("/chapters") ||
    isParentPath("/create/chapter") ||
    isParentPath("/chapter/:id/edit");

  const adminsRoutes = () =>
    isParentPath("/admins") ||
    isParentPath("/admins/create") ||
    isParentPath("/admins/:type/:id/edit");

  const categoryRoutes = () =>
    isParentPath("/category") ||
    isParentPath("/create/category") ||
    isParentPath("/category/:id/edit");

  const businessSubCategoryRoutes = () =>
    isParentPath("/business-sub-category") ||
    isParentPath("/create/business-sub-category") ||
    isParentPath("/business-sub-category/:id/edit");

  const incomeCategoryRoutes = () =>
    isParentPath("/income-category") ||
    isParentPath("/create/income-category") ||
    isParentPath("/income-category/:id/edit");

  const expenseCategoryRoutes = () =>
    isParentPath("/expense-category") ||
    isParentPath("/create/expense-category") ||
    isParentPath("/expense-category/:id/edit");

  const postsCategoryRoutes = () =>
    isParentPath("/posts-category") ||
    isParentPath("/create/posts-category") ||
    isParentPath("/posts-category/:id/edit");

  const sponsorsCategoryRoutes = () =>
    isParentPath("/sponsors-category") ||
    isParentPath("/create/sponsors-category") ||
    isParentPath("/sponsors-category/:id/edit");

  const bloodgroupRoutes = () =>
    isParentPath("/blood-groups") ||
    isParentPath("/create/blood-group") ||
    isParentPath("/blood-group/:id/edit");

  const currencyMasterRoutes = () =>
    isParentPath("/currency") ||
    isParentPath("/create/currency") ||
    isParentPath("/currency/:id/edit");

  const crownRoutes = () =>
    isParentPath("/crowns") ||
    isParentPath("/create/crown") ||
    isParentPath("/crown/:id/edit");

  const timerRoutes = () =>
    isParentPath("/timers") ||
    isParentPath("/create/timer") ||
    isParentPath("/timer/:id/edit");

  const timerAccessRoutes = () => isParentPath("/timer-access");

  const chapterFinanceAccessRoutes = () =>
    isParentPath("/chapter-finance-access");

  const roleRoutes = () =>
    isParentPath("/roles") ||
    isParentPath("/create/role") ||
    isParentPath("/role/:id/edit");

  const userRoleRoutes = () =>
    isParentPath("/user-roles") ||
    isParentPath("/create/user-role") ||
    isParentPath("/user-role/:id/edit");

  const tyfcbRoutes = () => isParentPath("/tyfcbs");

  const testimonialsRoutes = () => isParentPath("/testimonials");

  const meetingAttendanceRoutes = () => isParentPath("/weekly-meetings");
  const trainingRoutes = () =>
    isParentPath("/trainings") || isParentPath("/trainings/:id/attendance");

  const attendanceListRoutes = () => isParentPath("/attendance");

  const weeklyFeesRoutes = () => isParentPath("/weekly-fees");

  const onetooneRoutes = () => isParentPath("/one-to-one");

  const referralRoutes = () => isParentPath("/referrals");

  // const visitorRoutes = () =>
  //   isParentPath("/visitors");

  // Client: General / Chief Guest / Power Date paused — comment only, do not remove
  // const visitorGeneralRoutes = () => isParentPath("/visitors/general");
  // const visitorChiefGuestRoutes = () => isParentPath("/visitors/chief-guest");
  // const visitorPowerDateRoutes = () => isParentPath("/visitors/power-date");

  const visitorInductionsRoutes = () => isParentPath("/visitors/inductions");

  const weeklyMeetingFeesRoutes = () => isParentPath("/weekly-meeting-fees");

  const eventRoutes = () =>
    isParentPath("/events") ||
    isParentPath("/create/event") ||
    isParentPath("/event/:id/edit");

  const newsRoutes = () =>
    isParentPath("/news") ||
    isParentPath("/news/create") ||
    isParentPath("/news/:id/edit");

  const feedPostsRoutes = () => isParentPath("/feed-posts");

  const incomesRoutes = () => isParentPath("/incomes");

  const expensesRoutes = () => isParentPath("/expenses");

  const sponsorsRoutes = () => isParentPath("/sponsors");

  const pointsRoutes = () => isParentPath("/reports/points");
  const monthlyPointsRoutes = () => isParentPath("/reports/monthly-points");

  const settingsRoutes = () => isParentPath("/settings");

  const forumSettingsRoutes = () => isParentPath("/forum-settings");

  const tyfcbReportsRoutes = () => isParentPath("/reports/tyfcbs");

  const bizgivenReportsRoutes = () => isParentPath("/reports/biz-given");

  const onetooneReportsRoutes = () => isParentPath("/reports/one-to-one");

  const referralReportsRoutes = () => isParentPath("/reports/referrals");

  const visitorsReportsRoutes = () => isParentPath("/reports/visitors");

  const feesReportsRoutes = () => isParentPath("/reports/fees");

  const overallReportsRoutes = () => isParentPath("/reports/overall");

  const ledgerReportsRoutes = () => isParentPath("/reports/ledger");

  const membershipExpiryRenewalReportsRoutes = () =>
    isParentPath("/reports/membership-expiry-renewals");

  const attendanceReportsRoutes = () => isParentPath("/reports/attendance");
  const trainingReportsRoutes = () => isParentPath("/reports/training");

  const memberMonthlyReportsRoutes = () =>
    isParentPath("/member_monthly_reports");

  const pointsSystemRoutes = () => isParentPath("/points-system");

  useEffect(() => {
    if (
      isParentPath("/reports/tyfcbs") ||
      isParentPath("/reports/biz-given") ||
      isParentPath("/reports/one-to-one") ||
      isParentPath("/reports/referrals") ||
      isParentPath("/reports/visitors") ||
      isParentPath("/reports/fees") ||
      isParentPath("/reports/attendance") ||
      isParentPath("/reports/training") ||
      isParentPath("/reports/overall") ||
      isParentPath("/reports/ledger") ||
      isParentPath("/reports/membership-expiry-renewals") ||
      isParentPath("/member_monthly_reports") ||
      isParentPath("/reports/points") ||
      isParentPath("/reports/monthly-points")
    ) {
      setShowReportsSubMenu(true);
    } else {
      setShowReportsSubMenu(false);
    }

    // Client: Visitors submenu removed — Inductions is main menu now
    // if (
    //   // isParentPath("/visitors/general") ||
    //   // isParentPath("/visitors/chief-guest") ||
    //   // isParentPath("/visitors/power-date") ||
    //   isParentPath("/visitors/inductions")
    // ) {
    //   setShowVisitorsSubMenu(true);
    // } else {
    //   setShowVisitorsSubMenu(false);
    // }

    if (
      isParentPath("/countries") ||
      isParentPath("/create/country") ||
      isParentPath("/region/:id/country") ||
      isParentPath("/states") ||
      isParentPath("/create/state") ||
      isParentPath("/region/:id/state") ||
      isParentPath("/citys") ||
      isParentPath("/create/city") ||
      isParentPath("/city/:id/edit") ||
      isParentPath("/regions") ||
      isParentPath("/create/region") ||
      isParentPath("/region/:id/edit") ||
      adminsRoutes() ||
      isParentPath("/chapters") ||
      isParentPath("/create/chapter") ||
      isParentPath("/chapter/:id/edit") ||
      isParentPath("/blood-groups") ||
      isParentPath("/create/blood-group") ||
      isParentPath("/blood-group/:id/edit") ||
      isParentPath("/timers") ||
      isParentPath("/create/timer") ||
      isParentPath("/timer/:id/edit") ||
      isParentPath("/timer-access") ||
      isParentPath("/chapter-finance-access") ||
      isParentPath("/category") ||
      isParentPath("/create/category") ||
      isParentPath("/category/:id/edit") ||
      isParentPath("/business-sub-category") ||
      isParentPath("/create/business-sub-category") ||
      isParentPath("/business-sub-category/:id/edit") ||
      isParentPath("/income-category") ||
      isParentPath("/create/income-category") ||
      isParentPath("/income-category/:id/edit") ||
      isParentPath("/expense-category") ||
      isParentPath("/create/expense-category") ||
      isParentPath("/expense-category/:id/edit") ||
      isParentPath("/posts-category") ||
      isParentPath("/create/posts-category") ||
      isParentPath("/posts-category/:id/edit") ||
      isParentPath("/sponsors-category") ||
      isParentPath("/create/sponsors-category") ||
      isParentPath("/sponsors-category/:id/edit") ||
      isParentPath("/crowns") ||
      isParentPath("/create/crown") ||
      isParentPath("/crown/:id/edit") ||
      isParentPath("/user-roles") ||
      isParentPath("/create/user-role") ||
      isParentPath("/user-role/:id/edit") ||
      isParentPath("/currency") ||
      isParentPath("/create/currency") ||
      isParentPath("/currency/:id/edit")
    ) {
      setShowMastersSubMenu(true);
    } else {
      setShowMastersSubMenu(false);
    }
  }, [location]);

  const toggleMastersSubMenu = () => {
    setShowMastersSubMenu(!showMastersSubMenu);
  };

  const toggleReportsSubMenu = () => {
    setShowReportsSubMenu(!showReportsSubMenu);
  };

  const toggleVisitorsSubMenu = () => {
    setShowVisitorsSubMenu(!showVisitorsSubMenu);
  };

  return (
    <aside
      id="layout-menu"
      className="layout-menu menu-vertical menu bg-menu-theme darkbg"
    >
      <div className="app-brand demo text-center">
        <Link to="/" className="app-brand-link d-block">
          <span className="app-brand-text demo menu-text fw-bolder ms-2">
            <img src={logo} alt="Logo" />
          </span>
        </Link>
        <div
          className="layout-menu-toggle menu-link text-large ms-auto"
          onClick={closeDrawer}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#fff"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </div>
      </div>

      <div className="menu-inner-shadow"></div>

      <ul className="menu-inner dark-bg-inner py-3">
        <li className={dashboardRoute() ? "menu-item active" : "menu-item"}>
          <Link className="menu-link" to="/dashboard" onClick={closeDrawer}>
            <div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.32"
                  d="M21.1808 16.9703C20.8971 17.6255 20.2225 18 19.5086 18H14.8154C14.8462 17.9145 14.8735 17.8269 14.8971 17.7373C15.1709 16.6974 14.8825 15.639 14.2214 14.8963C14.4654 12.9091 14.6177 10.8733 14.7108 9.26516C14.7569 8.46731 13.7795 8.20081 13.4274 8.91526C12.7178 10.3553 11.8493 12.1958 11.0842 14.041C10.1467 14.3479 9.3768 15.1177 9.10295 16.1576C8.93642 16.7899 8.97782 17.4291 9.18451 18H4.49141C3.77747 18 3.10288 17.6255 2.81918 16.9703C2.29212 15.7533 2 14.4108 2 13C2 7.47715 6.47715 3 12 3C17.5229 3 22 7.47715 22 13C22 14.4108 21.7079 15.7533 21.1808 16.9703Z"
                />
                <path d="M14.7108 9.26516C14.7569 8.46731 13.7795 8.20081 13.4274 8.91526C12.7178 10.3553 11.8493 12.1958 11.0842 14.041C10.1467 14.3479 9.3768 15.1177 9.10295 16.1576C8.6742 17.7856 9.62375 19.459 11.2238 19.8953C12.8238 20.3315 14.4684 19.3654 14.8971 17.7373C15.1709 16.6974 14.8825 15.639 14.2214 14.8963C14.4654 12.9091 14.6177 10.8733 14.7108 9.26516Z" />
              </svg>
            </div>
            <div data-i18n="Analytics">Dashboard</div>
          </Link>
        </li>

        {hasPermission("members-list") && (
          <li className={userRoutes() ? "menu-item active" : "menu-item"}>
            <Link className="menu-link" to="/users" onClick={closeDrawer}>
              <div>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.32"
                    d="M2.28099 19.6575C2.36966 20.5161 2.93261 21.1957 3.77688 21.3755C5.1095 21.6592 7.6216 22 12 22C16.3784 22 18.8905 21.6592 20.2232 21.3755C21.0674 21.1957 21.6303 20.5161 21.719 19.6575C21.8505 18.3844 22 16.0469 22 12C22 7.95305 21.8505 5.6156 21.719 4.34251C21.6303 3.48389 21.0674 2.80424 20.2231 2.62451C18.8905 2.34081 16.3784 2 12 2C7.6216 2 5.1095 2.34081 3.77688 2.62451C2.93261 2.80424 2.36966 3.48389 2.28099 4.34251C2.14952 5.6156 2 7.95305 2 12C2 16.0469 2.14952 18.3844 2.28099 19.6575Z"
                  />
                  <path d="M13.9382 13.8559C15.263 13.1583 16.1663 11.7679 16.1663 10.1666C16.1663 7.8655 14.3008 6 11.9996 6C9.69841 6 7.83291 7.8655 7.83291 10.1666C7.83291 11.768 8.73626 13.1584 10.0612 13.856C8.28691 14.532 6.93216 16.1092 6.51251 18.0529C6.45446 18.3219 6.60246 18.5981 6.87341 18.6471C7.84581 18.8231 9.45616 19 12.0006 19C14.545 19 16.1554 18.8231 17.1278 18.6471C17.3977 18.5983 17.5454 18.3231 17.4876 18.0551C17.0685 16.1103 15.7133 14.5321 13.9382 13.8559Z" />
                </svg>
              </div>
              <div data-i18n="Analytics">Members</div>
            </Link>
          </li>
        )}

        {hasPermission("meeting-schedules-list") && (
          <li
            className={
              meetingAttendanceRoutes() ? "menu-item active" : "menu-item"
            }
          >
            <Link
              className="menu-link"
              to="/weekly-meetings"
              onClick={closeDrawer}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.32"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M2.12411 8H21.8758C21.9467 9.20109 22 10.8266 22 13C22 16.4843 21.8631 18.5605 21.7362 19.7371C21.6422 20.6088 21.0518 21.281 20.1903 21.4442C18.8494 21.6983 16.3428 22 12 22C7.65725 22 5.15055 21.6983 3.80967 21.4442C2.94826 21.281 2.35785 20.6088 2.26379 19.7371C2.13682 18.5605 2 16.4843 2 13C2 10.8266 2.05324 9.20109 2.12411 8ZM6.5 12.6815C6.5 12.0806 6.93315 11.6082 7.5337 11.5868C8.3136 11.559 9.6669 11.5275 12 11.5069C14.5069 11.4848 15.8826 11.5197 16.6312 11.5599C17.1554 11.5881 17.5 11.9946 17.5 12.5196V12.9107C17.5 13.4726 17.1157 13.9093 16.5543 13.934C15.7898 13.9675 14.4235 14 12 14C9.5765 14 8.21025 13.9675 7.44565 13.934C6.88435 13.9093 6.5 13.4726 6.5 12.9107V12.6815ZM6.5 17.0891C6.5 16.5276 6.8844 16.0793 7.44515 16.0503C7.97275 16.0231 8.7795 16.0001 10 16.0001C11.2205 16.0001 12.0272 16.0231 12.5548 16.0503C13.1156 16.0793 13.5 16.5276 13.5 17.0891V17.4111C13.5 17.9726 13.1156 18.4208 12.5548 18.4498C12.0272 18.4771 11.2205 18.5001 10 18.5001C8.7795 18.5001 7.97275 18.4771 7.44515 18.4498C6.8844 18.4208 6.5 17.9726 6.5 17.4111V17.0891Z"
                />
                <path d="M17.915 2.03126C18.2276 2.05703 18.4424 2.28598 18.4636 2.59889C18.4831 2.88636 18.5 3.32917 18.5 4C18.5 4.10776 18.4995 4.20964 18.4987 4.30593C19.1999 4.38632 19.7561 4.47356 20.1902 4.55581C21.0516 4.71901 21.642 5.39115 21.7361 6.26285C21.7839 6.7055 21.833 7.27555 21.8758 8H2.12402C2.16677 7.27555 2.21593 6.7055 2.2637 6.26285C2.35776 5.39115 2.94817 4.71902 3.80958 4.55581C4.24369 4.47355 4.8 4.3863 5.50125 4.30591C5.50045 4.20962 5.5 4.10775 5.5 4C5.5 3.32917 5.5169 2.88636 5.5364 2.59889C5.5576 2.28598 5.7724 2.05703 6.08495 2.03126C6.29765 2.01372 6.5938 2 7 2C7.4062 2 7.70235 2.01372 7.91505 2.03126C8.2276 2.05703 8.4424 2.28598 8.4636 2.59889C8.4831 2.88636 8.5 3.32917 8.5 4C8.5 4.0254 8.5 4.05047 8.49995 4.07521C9.50645 4.02844 10.6666 4 11.9999 4C13.3332 4 14.4935 4.02845 15.5 4.07522L15.5 4C15.5 3.32917 15.5169 2.88636 15.5364 2.59889C15.5576 2.28598 15.7724 2.05703 16.0849 2.03126C16.2976 2.01372 16.5938 2 17 2C17.4062 2 17.7023 2.01372 17.915 2.03126Z" />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7.5337 11.5868C6.93315 11.6081 6.5 12.0805 6.5 12.6815V12.9107C6.5 13.4725 6.88435 13.9093 7.44565 13.9339C8.21025 13.9674 9.5765 14 12 14C14.4235 14 15.7897 13.9674 16.5543 13.9339C17.1156 13.9093 17.5 13.4725 17.5 12.9107V12.5196C17.5 11.9946 17.1554 11.5881 16.6312 11.5599C15.8825 11.5196 14.5069 11.4847 12 11.5069C9.6669 11.5274 8.3136 11.559 7.5337 11.5868ZM7.44515 16.0503C6.8844 16.0793 6.5 16.5275 6.5 17.089V17.411C6.5 17.9725 6.8844 18.4208 7.44515 18.4498C7.97275 18.477 8.7795 18.5 10 18.5C11.2205 18.5 12.0272 18.477 12.5548 18.4498C13.1156 18.4208 13.5 17.9725 13.5 17.411V17.089C13.5 16.5275 13.1156 16.0793 12.5548 16.0503C12.0272 16.023 11.2205 16 10 16C8.7795 16 7.97275 16.023 7.44515 16.0503Z"
                />
              </svg>

              <div data-i18n="Analytics">Meeting Schedules</div>
            </Link>
          </li>
        )}

        {hasPermission("meeting-schedules-list") && (
          <li
            className={
              attendanceListRoutes() ? "menu-item active" : "menu-item"
            }
          >
            <Link
              className="menu-link"
              to="/attendance"
              onClick={closeDrawer}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.32"
                  d="M2.28099 19.6575C2.36966 20.5161 2.93261 21.1957 3.77688 21.3755C5.1095 21.6592 7.6216 22 12 22C16.3784 22 18.8905 21.6592 20.2232 21.3755C21.0674 21.1957 21.6303 20.5161 21.719 19.6575C21.8505 18.3844 22 16.0469 22 12C22 7.95305 21.8505 5.6156 21.719 4.34251C21.6303 3.48389 21.0674 2.80424 20.2231 2.62451C18.8905 2.34081 16.3784 2 12 2C7.6216 2 5.1095 2.34081 3.77688 2.62451C2.93261 2.80424 2.36966 3.48389 2.28099 4.34251C2.14952 5.6156 2 7.95305 2 12C2 16.0469 2.14952 18.3844 2.28099 19.6575Z"
                />
                <path d="M13.9382 13.8559C15.263 13.1583 16.1663 11.7679 16.1663 10.1666C16.1663 7.8655 14.3008 6 11.9996 6C9.69841 6 7.83291 7.8655 7.83291 10.1666C7.83291 11.768 8.73626 13.1584 10.0612 13.856C8.28691 14.532 6.93216 16.1092 6.51251 18.0529C6.45446 18.3219 6.60246 18.5981 6.87341 18.6471C7.84581 18.8231 9.45616 19 12.0006 19C14.545 19 16.1554 18.8231 17.1278 18.6471C17.3977 18.5983 17.5454 18.3231 17.4876 18.0551C17.0685 16.1103 15.7133 14.5321 13.9382 13.8559Z" />
                <path d="M18.5 9.5L20 11L22.5 8.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>

              <div data-i18n="Analytics">Attendance</div>
            </Link>
          </li>
        )}

        {hasPermission("meeting-fees-list") && (
          <li className={weeklyFeesRoutes() ? "menu-item active" : "menu-item"}>
            <Link className="menu-link" to="/weekly-fees" onClick={closeDrawer}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.32"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M2.12411 8H21.8758C21.9467 9.20109 22 10.8266 22 13C22 16.4843 21.8631 18.5605 21.7362 19.7371C21.6422 20.6088 21.0518 21.281 20.1903 21.4442C18.8494 21.6983 16.3428 22 12 22C7.65725 22 5.15055 21.6983 3.80967 21.4442C2.94826 21.281 2.35785 20.6088 2.26379 19.7371C2.13682 18.5605 2 16.4843 2 13C2 10.8266 2.05324 9.20109 2.12411 8ZM6.5 12.6815C6.5 12.0806 6.93315 11.6082 7.5337 11.5868C8.3136 11.559 9.6669 11.5275 12 11.5069C14.5069 11.4848 15.8826 11.5197 16.6312 11.5599C17.1554 11.5881 17.5 11.9946 17.5 12.5196V12.9107C17.5 13.4726 17.1157 13.9093 16.5543 13.934C15.7898 13.9675 14.4235 14 12 14C9.5765 14 8.21025 13.9675 7.44565 13.934C6.88435 13.9093 6.5 13.4726 6.5 12.9107V12.6815ZM6.5 17.0891C6.5 16.5276 6.8844 16.0793 7.44515 16.0503C7.97275 16.0231 8.7795 16.0001 10 16.0001C11.2205 16.0001 12.0272 16.0231 12.5548 16.0503C13.1156 16.0793 13.5 16.5276 13.5 17.0891V17.4111C13.5 17.9726 13.1156 18.4208 12.5548 18.4498C12.0272 18.4771 11.2205 18.5001 10 18.5001C8.7795 18.5001 7.97275 18.4771 7.44515 18.4498C6.8844 18.4208 6.5 17.9726 6.5 17.4111V17.0891Z"
                />
                <path d="M17.915 2.03126C18.2276 2.05703 18.4424 2.28598 18.4636 2.59889C18.4831 2.88636 18.5 3.32917 18.5 4C18.5 4.10776 18.4995 4.20964 18.4987 4.30593C19.1999 4.38632 19.7561 4.47356 20.1902 4.55581C21.0516 4.71901 21.642 5.39115 21.7361 6.26285C21.7839 6.7055 21.833 7.27555 21.8758 8H2.12402C2.16677 7.27555 2.21593 6.7055 2.2637 6.26285C2.35776 5.39115 2.94817 4.71902 3.80958 4.55581C4.24369 4.47355 4.8 4.3863 5.50125 4.30591C5.50045 4.20962 5.5 4.10775 5.5 4C5.5 3.32917 5.5169 2.88636 5.5364 2.59889C5.5576 2.28598 5.7724 2.05703 6.08495 2.03126C6.29765 2.01372 6.5938 2 7 2C7.4062 2 7.70235 2.01372 7.91505 2.03126C8.2276 2.05703 8.4424 2.28598 8.4636 2.59889C8.4831 2.88636 8.5 3.32917 8.5 4C8.5 4.0254 8.5 4.05047 8.49995 4.07521C9.50645 4.02844 10.6666 4 11.9999 4C13.3332 4 14.4935 4.02845 15.5 4.07522L15.5 4C15.5 3.32917 15.5169 2.88636 15.5364 2.59889C15.5576 2.28598 15.7724 2.05703 16.0849 2.03126C16.2976 2.01372 16.5938 2 17 2C17.4062 2 17.7023 2.01372 17.915 2.03126Z" />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7.5337 11.5868C6.93315 11.6081 6.5 12.0805 6.5 12.6815V12.9107C6.5 13.4725 6.88435 13.9093 7.44565 13.9339C8.21025 13.9674 9.5765 14 12 14C14.4235 14 15.7897 13.9674 16.5543 13.9339C17.1156 13.9093 17.5 13.4725 17.5 12.9107V12.5196C17.5 11.9946 17.1554 11.5881 16.6312 11.5599C15.8825 11.5196 14.5069 11.4847 12 11.5069C9.6669 11.5274 8.3136 11.559 7.5337 11.5868ZM7.44515 16.0503C6.8844 16.0793 6.5 16.5275 6.5 17.089V17.411C6.5 17.9725 6.8844 18.4208 7.44515 18.4498C7.97275 18.477 8.7795 18.5 10 18.5C11.2205 18.5 12.0272 18.477 12.5548 18.4498C13.1156 18.4208 13.5 17.9725 13.5 17.411V17.089C13.5 16.5275 13.1156 16.0793 12.5548 16.0503C12.0272 16.023 11.2205 16 10 16C8.7795 16 7.97275 16.023 7.44515 16.0503Z"
                />
              </svg>

              <div data-i18n="Analytics">Meeting Fees</div>
            </Link>
          </li>
        )}

        {hasPermission("training-list") && (
          <li className={trainingRoutes() ? "menu-item active" : "menu-item"}>
            <Link className="menu-link" to="/trainings" onClick={closeDrawer}>
              <i className="bx bx-book-reader" style={{ fontSize: 22 }}></i>
              <div data-i18n="Analytics">Training</div>
            </Link>
          </li>
        )}

        {hasPermission("121s-list") && (
          <li className={onetooneRoutes() ? "menu-item active" : "menu-item"}>
            <Link className="menu-link" to="/one-to-one" onClick={closeDrawer}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.32"
                  d="M2.28099 19.6575C2.36966 20.5161 2.93261 21.1957 3.77688 21.3755C5.1095 21.6592 7.6216 22 12 22C16.3784 22 18.8905 21.6592 20.2232 21.3755C21.0674 21.1957 21.6303 20.5161 21.719 19.6575C21.8505 18.3844 22 16.0469 22 12C22 7.95305 21.8505 5.6156 21.719 4.34251C21.6303 3.48389 21.0674 2.80424 20.2231 2.62451C18.8905 2.34081 16.3784 2 12 2C7.6216 2 5.1095 2.34081 3.77688 2.62451C2.93261 2.80424 2.36966 3.48389 2.28099 4.34251C2.14952 5.6156 2 7.95305 2 12C2 16.0469 2.14952 18.3844 2.28099 19.6575Z"
                />
                <path d="M13.9382 13.8559C15.263 13.1583 16.1663 11.7679 16.1663 10.1666C16.1663 7.8655 14.3008 6 11.9996 6C9.69841 6 7.83291 7.8655 7.83291 10.1666C7.83291 11.768 8.73626 13.1584 10.0612 13.856C8.28691 14.532 6.93216 16.1092 6.51251 18.0529C6.45446 18.3219 6.60246 18.5981 6.87341 18.6471C7.84581 18.8231 9.45616 19 12.0006 19C14.545 19 16.1554 18.8231 17.1278 18.6471C17.3977 18.5983 17.5454 18.3231 17.4876 18.0551C17.0685 16.1103 15.7133 14.5321 13.9382 13.8559Z" />
              </svg>
              <div data-i18n="Analytics">Personal Meet</div>
            </Link>
          </li>
        )}
        {hasPermission("referrals-list") && (
          <li className={referralRoutes() ? "menu-item active" : "menu-item"}>
            <Link className="menu-link" to="/referrals" onClick={closeDrawer}>
              <div>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.32"
                    d="M2.28099 19.6575C2.36966 20.5161 2.93261 21.1957 3.77688 21.3755C5.1095 21.6592 7.6216 22 12 22C16.3784 22 18.8905 21.6592 20.2232 21.3755C21.0674 21.1957 21.6303 20.5161 21.719 19.6575C21.8505 18.3844 22 16.0469 22 12C22 7.95305 21.8505 5.6156 21.719 4.34251C21.6303 3.48389 21.0674 2.80424 20.2231 2.62451C18.8905 2.34081 16.3784 2 12 2C7.6216 2 5.1095 2.34081 3.77688 2.62451C2.93261 2.80424 2.36966 3.48389 2.28099 4.34251C2.14952 5.6156 2 7.95305 2 12C2 16.0469 2.14952 18.3844 2.28099 19.6575Z"
                  />
                  <path d="M13.9382 13.8559C15.263 13.1583 16.1663 11.7679 16.1663 10.1666C16.1663 7.8655 14.3008 6 11.9996 6C9.69841 6 7.83291 7.8655 7.83291 10.1666C7.83291 11.768 8.73626 13.1584 10.0612 13.856C8.28691 14.532 6.93216 16.1092 6.51251 18.0529C6.45446 18.3219 6.60246 18.5981 6.87341 18.6471C7.84581 18.8231 9.45616 19 12.0006 19C14.545 19 16.1554 18.8231 17.1278 18.6471C17.3977 18.5983 17.5454 18.3231 17.4876 18.0551C17.0685 16.1103 15.7133 14.5321 13.9382 13.8559Z" />
                </svg>
              </div>
              <div data-i18n="Analytics">Professional Connect</div>
            </Link>
          </li>
        )}

        {hasPermission("tyfcbs-list") && (
          <li className={tyfcbRoutes() ? "menu-item active" : "menu-item"}>
            <Link className="menu-link" to="/tyfcbs" onClick={closeDrawer}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-emoji-smile-fill"
                viewBox="0 0 16 16"
              >
                {" "}
                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zM4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8z" />{" "}
              </svg>
              <div data-i18n="Analytics">Gratitude Note</div>
            </Link>
          </li>
        )}

        {/* Client: Visitors parent menu hidden — Inductions as main menu. Old Visitors dropdown kept commented.
        {(hasPermission("visitors-general-list") ||
          hasPermission("visitors-chief-guest-list") ||
          hasPermission("visitors-power-date-list") ||
          hasPermission("visitors-inductions-list")) && (
            <li
              className="menu-item dropdown_menu"
              onClick={toggleVisitorsSubMenu}
            >
              ...
            </li>
          )}
        */}
        {hasPermission("visitors-inductions-list") && (
          <li
            className={
              visitorInductionsRoutes() ? "menu-item active" : "menu-item"
            }
          >
            <Link
              className="menu-link"
              to="/visitors/inductions"
              onClick={closeDrawer}
            >
              <i className="bx bx-user-check"></i>
              <div data-i18n="Analytics">Inductions</div>
            </Link>
          </li>
        )}

        {hasPermission("events-list") && (
          <li className={eventRoutes() ? "menu-item active" : "menu-item"}>
            <Link className="menu-link" to="/events" onClick={closeDrawer}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.32"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M2.12411 8H21.8758C21.9467 9.20109 22 10.8266 22 13C22 16.4843 21.8631 18.5605 21.7362 19.7371C21.6422 20.6088 21.0518 21.281 20.1903 21.4442C18.8494 21.6983 16.3428 22 12 22C7.65725 22 5.15055 21.6983 3.80967 21.4442C2.94826 21.281 2.35785 20.6088 2.26379 19.7371C2.13682 18.5605 2 16.4843 2 13C2 10.8266 2.05324 9.20109 2.12411 8ZM6.5 12.6815C6.5 12.0806 6.93315 11.6082 7.5337 11.5868C8.3136 11.559 9.6669 11.5275 12 11.5069C14.5069 11.4848 15.8826 11.5197 16.6312 11.5599C17.1554 11.5881 17.5 11.9946 17.5 12.5196V12.9107C17.5 13.4726 17.1157 13.9093 16.5543 13.934C15.7898 13.9675 14.4235 14 12 14C9.5765 14 8.21025 13.9675 7.44565 13.934C6.88435 13.9093 6.5 13.4726 6.5 12.9107V12.6815ZM6.5 17.0891C6.5 16.5276 6.8844 16.0793 7.44515 16.0503C7.97275 16.0231 8.7795 16.0001 10 16.0001C11.2205 16.0001 12.0272 16.0231 12.5548 16.0503C13.1156 16.0793 13.5 16.5276 13.5 17.0891V17.4111C13.5 17.9726 13.1156 18.4208 12.5548 18.4498C12.0272 18.4771 11.2205 18.5001 10 18.5001C8.7795 18.5001 7.97275 18.4771 7.44515 18.4498C6.8844 18.4208 6.5 17.9726 6.5 17.4111V17.0891Z"
                />
                <path d="M17.915 2.03126C18.2276 2.05703 18.4424 2.28598 18.4636 2.59889C18.4831 2.88636 18.5 3.32917 18.5 4C18.5 4.10776 18.4995 4.20964 18.4987 4.30593C19.1999 4.38632 19.7561 4.47356 20.1902 4.55581C21.0516 4.71901 21.642 5.39115 21.7361 6.26285C21.7839 6.7055 21.833 7.27555 21.8758 8H2.12402C2.16677 7.27555 2.21593 6.7055 2.2637 6.26285C2.35776 5.39115 2.94817 4.71902 3.80958 4.55581C4.24369 4.47355 4.8 4.3863 5.50125 4.30591C5.50045 4.20962 5.5 4.10775 5.5 4C5.5 3.32917 5.5169 2.88636 5.5364 2.59889C5.5576 2.28598 5.7724 2.05703 6.08495 2.03126C6.29765 2.01372 6.5938 2 7 2C7.4062 2 7.70235 2.01372 7.91505 2.03126C8.2276 2.05703 8.4424 2.28598 8.4636 2.59889C8.4831 2.88636 8.5 3.32917 8.5 4C8.5 4.0254 8.5 4.05047 8.49995 4.07521C9.50645 4.02844 10.6666 4 11.9999 4C13.3332 4 14.4935 4.02845 15.5 4.07522L15.5 4C15.5 3.32917 15.5169 2.88636 15.5364 2.59889C15.5576 2.28598 15.7724 2.05703 16.0849 2.03126C16.2976 2.01372 16.5938 2 17 2C17.4062 2 17.7023 2.01372 17.915 2.03126Z" />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7.5337 11.5868C6.93315 11.6081 6.5 12.0805 6.5 12.6815V12.9107C6.5 13.4725 6.88435 13.9093 7.44565 13.9339C8.21025 13.9674 9.5765 14 12 14C14.4235 14 15.7897 13.9674 16.5543 13.9339C17.1156 13.9093 17.5 13.4725 17.5 12.9107V12.5196C17.5 11.9946 17.1554 11.5881 16.6312 11.5599C15.8825 11.5196 14.5069 11.4847 12 11.5069C9.6669 11.5274 8.3136 11.559 7.5337 11.5868ZM7.44515 16.0503C6.8844 16.0793 6.5 16.5275 6.5 17.089V17.411C6.5 17.9725 6.8844 18.4208 7.44515 18.4498C7.97275 18.477 8.7795 18.5 10 18.5C11.2205 18.5 12.0272 18.477 12.5548 18.4498C13.1156 18.4208 13.5 17.9725 13.5 17.411V17.089C13.5 16.5275 13.1156 16.0793 12.5548 16.0503C12.0272 16.023 11.2205 16 10 16C8.7795 16 7.97275 16.023 7.44515 16.0503Z"
                />
              </svg>
              <div data-i18n="Analytics">Events</div>
            </Link>
          </li>
        )}

        {hasPermission("news-list") && (
          <li className={newsRoutes() ? "menu-item active" : "menu-item"}>
            <Link className="menu-link" to="/news" onClick={closeDrawer}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.32"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M2.12411 8H21.8758C21.9467 9.20109 22 10.8266 22 13C22 16.4843 21.8631 18.5605 21.7362 19.7371C21.6422 20.6088 21.0518 21.281 20.1903 21.4442C18.8494 21.6983 16.3428 22 12 22C7.65725 22 5.15055 21.6983 3.80967 21.4442C2.94826 21.281 2.35785 20.6088 2.26379 19.7371C2.13682 18.5605 2 16.4843 2 13C2 10.8266 2.05324 9.20109 2.12411 8ZM6.5 12.6815C6.5 12.0806 6.93315 11.6082 7.5337 11.5868C8.3136 11.559 9.6669 11.5275 12 11.5069C14.5069 11.4848 15.8826 11.5197 16.6312 11.5599C17.1554 11.5881 17.5 11.9946 17.5 12.5196V12.9107C17.5 13.4726 17.1157 13.9093 16.5543 13.934C15.7898 13.9675 14.4235 14 12 14C9.5765 14 8.21025 13.9675 7.44565 13.934C6.88435 13.9093 6.5 13.4726 6.5 12.9107V12.6815ZM6.5 17.0891C6.5 16.5276 6.8844 16.0793 7.44515 16.0503C7.97275 16.0231 8.7795 16.0001 10 16.0001C11.2205 16.0001 12.0272 16.0231 12.5548 16.0503C13.1156 16.0793 13.5 16.5276 13.5 17.0891V17.4111C13.5 17.9726 13.1156 18.4208 12.5548 18.4498C12.0272 18.4771 11.2205 18.5001 10 18.5001C8.7795 18.5001 7.97275 18.4771 7.44515 18.4498C6.8844 18.4208 6.5 17.9726 6.5 17.4111V17.0891Z"
                />
                <path d="M17.915 2.03126C18.2276 2.05703 18.4424 2.28598 18.4636 2.59889C18.4831 2.88636 18.5 3.32917 18.5 4C18.5 4.10776 18.4995 4.20964 18.4987 4.30593C19.1999 4.38632 19.7561 4.47356 20.1902 4.55581C21.0516 4.71901 21.642 5.39115 21.7361 6.26285C21.7839 6.7055 21.833 7.27555 21.8758 8H2.12402C2.16677 7.27555 2.21593 6.7055 2.2637 6.26285C2.35776 5.39115 2.94817 4.71902 3.80958 4.55581C4.24369 4.47355 4.8 4.3863 5.50125 4.30591C5.50045 4.20962 5.5 4.10775 5.5 4C5.5 3.32917 5.5169 2.88636 5.5364 2.59889C5.5576 2.28598 5.7724 2.05703 6.08495 2.03126C6.29765 2.01372 6.5938 2 7 2C7.4062 2 7.70235 2.01372 7.91505 2.03126C8.2276 2.05703 8.4424 2.28598 8.4636 2.59889C8.4831 2.88636 8.5 3.32917 8.5 4C8.5 4.0254 8.5 4.05047 8.49995 4.07521C9.50645 4.02844 10.6666 4 11.9999 4C13.3332 4 14.4935 4.02845 15.5 4.07522L15.5 4C15.5 3.32917 15.5169 2.88636 15.5364 2.59889C15.5576 2.28598 15.7724 2.05703 16.0849 2.03126C16.2976 2.01372 16.5938 2 17 2C17.4062 2 17.7023 2.01372 17.915 2.03126Z" />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7.5337 11.5868C6.93315 11.6081 6.5 12.0805 6.5 12.6815V12.9107C6.5 13.4725 6.88435 13.9093 7.44565 13.9339C8.21025 13.9674 9.5765 14 12 14C14.4235 14 15.7897 13.9674 16.5543 13.9339C17.1156 13.9093 17.5 13.4725 17.5 12.9107V12.5196C17.5 11.9946 17.1554 11.5881 16.6312 11.5599C15.8825 11.5196 14.5069 11.4847 12 11.5069C9.6669 11.5274 8.3136 11.559 7.5337 11.5868ZM7.44515 16.0503C6.8844 16.0793 6.5 16.5275 6.5 17.089V17.411C6.5 17.9725 6.8844 18.4208 7.44515 18.4498C7.97275 18.477 8.7795 18.5 10 18.5C11.2205 18.5 12.0272 18.477 12.5548 18.4498C13.1156 18.4208 13.5 17.9725 13.5 17.411V17.089C13.5 16.5275 13.1156 16.0793 12.5548 16.0503C12.0272 16.023 11.2205 16 10 16C8.7795 16 7.97275 16.023 7.44515 16.0503Z"
                />
              </svg>
              <div data-i18n="Analytics">News Feed</div>
            </Link>
          </li>
        )}

        {hasPermission("feed-posts-list") && (
          <li className={feedPostsRoutes() ? "menu-item active" : "menu-item"}>
            <Link className="menu-link" to="/feed-posts" onClick={closeDrawer}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.32"
                  d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3ZM19 19H5V5H19V19Z"
                  fill="currentColor"
                />
                <rect x="7" y="7" width="10" height="2" fill="currentColor" />
                <rect x="7" y="11" width="10" height="2" fill="currentColor" />
                <rect x="7" y="15" width="6" height="2" fill="currentColor" />
              </svg>
              <div data-i18n="Analytics">Leads</div>
            </Link>
          </li>
        )}

        {hasPermission("incomes-list") && (
          <li className={incomesRoutes() ? "menu-item active" : "menu-item"}>
            <Link className="menu-link" to="/incomes" onClick={closeDrawer}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.32"
                  d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                  fill="currentColor"
                />
                <path
                  d="M13 7H11V9H9V11H13V13H9V17H11V19H13V17H15V15H11V13H15V9H13V7Z"
                  fill="currentColor"
                />
              </svg>
              <div data-i18n="Analytics">Incomes</div>
            </Link>
          </li>
        )}

        {hasPermission("expenses-list") && (
          <li className={expensesRoutes() ? "menu-item active" : "menu-item"}>
            <Link className="menu-link" to="/expenses" onClick={closeDrawer}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.32"
                  d="M3 6V18H21V6H3ZM19 8H5V16H19V8Z"
                  fill="currentColor"
                />
                <path
                  d="M12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z"
                  fill="currentColor"
                />
                <circle cx="7" cy="12" r="1.5" fill="currentColor" />
                <circle cx="17" cy="12" r="1.5" fill="currentColor" />
              </svg>
              <div data-i18n="Analytics">Expenses</div>
            </Link>
          </li>
        )}

        {hasPermission("sponsors-list") && (
          <li className={sponsorsRoutes() ? "menu-item active" : "menu-item"}>
            <Link className="menu-link" to="/sponsors" onClick={closeDrawer}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.32"
                  d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                  fill="currentColor"
                />
                <path
                  d="M13 7H11V9H9V11H13V13H9V17H11V19H13V17H15V15H11V13H15V9H13V7Z"
                  fill="currentColor"
                />
              </svg>
              <div data-i18n="Analytics">Sponsors</div>
            </Link>
          </li>
        )}

        {hasPermission("testimonials-list") && (
          <li
            className={testimonialsRoutes() ? "menu-item active" : "menu-item"}
          >
            <Link
              className="menu-link"
              to="/testimonials"
              onClick={closeDrawer}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.32"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M2.12411 8H21.8758C21.9467 9.20109 22 10.8266 22 13C22 16.4843 21.8631 18.5605 21.7362 19.7371C21.6422 20.6088 21.0518 21.281 20.1903 21.4442C18.8494 21.6983 16.3428 22 12 22C7.65725 22 5.15055 21.6983 3.80967 21.4442C2.94826 21.281 2.35785 20.6088 2.26379 19.7371C2.13682 18.5605 2 16.4843 2 13C2 10.8266 2.05324 9.20109 2.12411 8ZM6.5 12.6815C6.5 12.0806 6.93315 11.6082 7.5337 11.5868C8.3136 11.559 9.6669 11.5275 12 11.5069C14.5069 11.4848 15.8826 11.5197 16.6312 11.5599C17.1554 11.5881 17.5 11.9946 17.5 12.5196V12.9107C17.5 13.4726 17.1157 13.9093 16.5543 13.934C15.7898 13.9675 14.4235 14 12 14C9.5765 14 8.21025 13.9675 7.44565 13.934C6.88435 13.9093 6.5 13.4726 6.5 12.9107V12.6815ZM6.5 17.0891C6.5 16.5276 6.8844 16.0793 7.44515 16.0503C7.97275 16.0231 8.7795 16.0001 10 16.0001C11.2205 16.0001 12.0272 16.0231 12.5548 16.0503C13.1156 16.0793 13.5 16.5276 13.5 17.0891V17.4111C13.5 17.9726 13.1156 18.4208 12.5548 18.4498C12.0272 18.4771 11.2205 18.5001 10 18.5001C8.7795 18.5001 7.97275 18.4771 7.44515 18.4498C6.8844 18.4208 6.5 17.9726 6.5 17.4111V17.0891Z"
                />
                <path d="M17.915 2.03126C18.2276 2.05703 18.4424 2.28598 18.4636 2.59889C18.4831 2.88636 18.5 3.32917 18.5 4C18.5 4.10776 18.4995 4.20964 18.4987 4.30593C19.1999 4.38632 19.7561 4.47356 20.1902 4.55581C21.0516 4.71901 21.642 5.39115 21.7361 6.26285C21.7839 6.7055 21.833 7.27555 21.8758 8H2.12402C2.16677 7.27555 2.21593 6.7055 2.2637 6.26285C2.35776 5.39115 2.94817 4.71902 3.80958 4.55581C4.24369 4.47355 4.8 4.3863 5.50125 4.30591C5.50045 4.20962 5.5 4.10775 5.5 4C5.5 3.32917 5.5169 2.88636 5.5364 2.59889C5.5576 2.28598 5.7724 2.05703 6.08495 2.03126C6.29765 2.01372 6.5938 2 7 2C7.4062 2 7.70235 2.01372 7.91505 2.03126C8.2276 2.05703 8.4424 2.28598 8.4636 2.59889C8.4831 2.88636 8.5 3.32917 8.5 4C8.5 4.0254 8.5 4.05047 8.49995 4.07521C9.50645 4.02844 10.6666 4 11.9999 4C13.3332 4 14.4935 4.02845 15.5 4.07522L15.5 4C15.5 3.32917 15.5169 2.88636 15.5364 2.59889C15.5576 2.28598 15.7724 2.05703 16.0849 2.03126C16.2976 2.01372 16.5938 2 17 2C17.4062 2 17.7023 2.01372 17.915 2.03126Z" />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7.5337 11.5868C6.93315 11.6081 6.5 12.0805 6.5 12.6815V12.9107C6.5 13.4725 6.88435 13.9093 7.44565 13.9339C8.21025 13.9674 9.5765 14 12 14C14.4235 14 15.7897 13.9674 16.5543 13.9339C17.1156 13.9093 17.5 13.4725 17.5 12.9107V12.5196C17.5 11.9946 17.1554 11.5881 16.6312 11.5599C15.8825 11.5196 14.5069 11.4847 12 11.5069C9.6669 11.5274 8.3136 11.559 7.5337 11.5868ZM7.44515 16.0503C6.8844 16.0793 6.5 16.5275 6.5 17.089V17.411C6.5 17.9725 6.8844 18.4208 7.44515 18.4498C7.97275 18.477 8.7795 18.5 10 18.5C11.2205 18.5 12.0272 18.477 12.5548 18.4498C13.1156 18.4208 13.5 17.9725 13.5 17.411V17.089C13.5 16.5275 13.1156 16.0793 12.5548 16.0503C12.0272 16.023 11.2205 16 10 16C8.7795 16 7.97275 16.023 7.44515 16.0503Z"
                />
              </svg>
              <div data-i18n="Analytics">Testimonials</div>
            </Link>
          </li>
        )}
        {(hasPermission("reports-tyns-list") ||
          hasPermission("reports-biz-given-list") ||
          hasPermission("reports-121s-list") ||
          hasPermission("reports-referrals-list") ||
          hasPermission("reports-visitors-list") ||
          hasPermission("reports-reward-points") ||
          hasPermission("reports-fees-list") ||
          hasPermission("reports-attendance-list") ||
          hasPermission("reports-training-list") ||
          hasPermission("training-list") ||
          hasPermission("reports-overall-list") ||
          hasPermission("reports-ledger-list") ||
          hasPermission("reports-membership-expiry-renewal-list")) && (
            <li
              className="menu-item dropdown_menu"
              onClick={toggleReportsSubMenu}
            >
              <div className="dropdown_title">
                <div className="dropdown_it">
                  <i className="bx bxs-report"></i>
                  <h2>Reports</h2>
                </div>
                <i
                  className={
                    showReportsSubMenu ? "bx bx-chevron-up" : "bx bx-chevron-down"
                  }
                ></i>
              </div>
              {showReportsSubMenu && (
                <ul className="sub-menu">
                  {hasPermission("reports-tyns-list") && (
                    <li>
                      <Link
                        className={
                          tyfcbReportsRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/reports/tyfcbs"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Gratitude Note</div>
                      </Link>
                    </li>
                  )}
                  {hasPermission("reports-biz-given-list") && (
                    <li>
                      <Link
                        className={
                          bizgivenReportsRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/reports/biz-given"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">BIZ Given</div>
                      </Link>
                    </li>
                  )}
                  {hasPermission("reports-121s-list") && (
                    <li>
                      <Link
                        className={
                          onetooneReportsRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/reports/one-to-one"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Personal Meet</div>
                      </Link>
                    </li>
                  )}
                  {hasPermission("reports-referrals-list") && (
                    <li>
                      <Link
                        className={
                          referralReportsRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/reports/referrals"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Professional Connect</div>
                      </Link>
                    </li>
                  )}
                  {hasPermission("reports-visitors-list") && (
                    <li>
                      <Link
                        className={
                          visitorsReportsRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/reports/visitors"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Inductions</div>
                      </Link>
                    </li>
                  )}
                  {hasPermission("reports-reward-points") && (
                    <>
                      <li>
                        <Link
                          className={
                            pointsRoutes()
                              ? "submenu-link active_submenu"
                              : "submenu-link"
                          }
                          to="/reports/points"
                          onClick={closeDrawer}
                        >
                          <div data-i18n="Analytics">Reward Points</div>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            monthlyPointsRoutes()
                              ? "submenu-link active_submenu"
                              : "submenu-link"
                          }
                          to="/reports/monthly-points"
                          onClick={closeDrawer}
                        >
                          <div data-i18n="Analytics">Monthly Points</div>
                        </Link>
                      </li>
                    </>
                  )}
                  {hasPermission("reports-fees-list") && (
                    <li>
                      <Link
                        className={
                          feesReportsRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/reports/fees"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Circle Pending Fee</div>
                      </Link>
                    </li>
                  )}
                  {hasPermission("reports-attendance-list") && (
                    <li>
                      <Link
                        className={
                          attendanceReportsRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/reports/attendance"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Attendance Reports</div>
                      </Link>
                    </li>
                  )}
                  {/* {(hasPermission("reports-training-list") ||
                    hasPermission("training-list") ||
                    hasPermission("reports-attendance-list")) && (
                    <li>
                      <Link
                        className={
                          trainingReportsRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/reports/training"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Training Reports</div>
                      </Link>
                    </li>
                  )} */}
                  {hasPermission("reports-overall-list") && (
                    <li>
                      <Link
                        className={
                          overallReportsRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/reports/overall"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Overall Reports</div>
                      </Link>
                    </li>
                  )}
                  {hasPermission("reports-membership-expiry-renewal-list") && (
                    <li>
                      <Link
                        className={
                          membershipExpiryRenewalReportsRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/reports/membership-expiry-renewals"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">
                          Membership Expiry & Renewals
                        </div>
                      </Link>
                    </li>
                  )}
                  {hasPermission("reports-ledger-list") && (
                    <li>
                      <Link
                        className={
                          ledgerReportsRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/reports/ledger"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Incomes & Expenses Ledger</div>
                      </Link>
                    </li>
                  )}
                  {/* {Boolean(isSuperAdmin) && (
                    <li>
                      <Link
                        className={
                          memberMonthlyReportsRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/member_monthly_reports"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">
                          Member Monthly Reports
                        </div>
                      </Link>
                    </li>
                  )} */}
                </ul>
              )}
            </li>
          )}

        {(hasPermission("countries-list") ||
          hasPermission("states-list") ||
          hasPermission("citys-list") ||
          hasPermission("regions-list") ||
          hasPermission("chapters-list") ||
          hasPermission("country-admins-list") ||
          hasPermission("state-admins-list") ||
          hasPermission("city-admins-list") ||
          hasPermission("region-admins-list") ||
          hasPermission("chapter-admins-list") ||
          hasPermission("user-roles-list") ||
          hasPermission("business-category-list") ||
          hasPermission("business-sub-category-list") ||
          hasPermission("income-category-list") ||
          hasPermission("expense-category-list") ||
          hasPermission("posts-category-list") ||
          hasPermission("sponsors-category-list") ||
          hasPermission("blood-groups-list") ||
          hasPermission("chapter-finance-access-list") ||
          hasPermission("currency-master-list")
          // || hasPermission("crowns-list") // Client: Crowns menu paused
          // || hasPermission("timers-list") // commented Timers menu
          // || hasPermission("timer-access-list") // commented Timer Access menu
          ) && (
            <li
              className="menu-item dropdown_menu"
              onClick={toggleMastersSubMenu}
            >
              <div className="dropdown_title">
                <div className="dropdown_it">
                  <i className="bx bxs-dashboard"></i>
                  <h2>Masters</h2>
                </div>
                <i
                  className={
                    showMastersSubMenu ? "bx bx-chevron-up" : "bx bx-chevron-down"
                  }
                ></i>
              </div>
              {showMastersSubMenu && (
                <ul className="sub-menu">
                  {hasPermission("countries-list") && (
                    <li>
                      <Link
                        className={
                          countryRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/countries"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Countries</div>
                      </Link>
                    </li>
                  )}
                  {hasPermission("states-list") && (
                    <li>
                      <Link
                        className={
                          stateRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/states"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">States</div>
                      </Link>
                    </li>
                  )}
                  {hasPermission("citys-list") && (
                    <li>
                      <Link
                        className={
                          cityRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/citys"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Cities</div>
                      </Link>
                    </li>
                  )}
                  {hasPermission("regions-list") && (
                    <li>
                      <Link
                        className={
                          regionRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/regions"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Regions</div>
                      </Link>
                    </li>
                  )}
                  {hasPermission("chapters-list") && (
                    <li>
                      <Link
                        className={
                          chapterRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/chapters"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Circles</div>
                      </Link>
                    </li>
                  )}
                  {(hasPermission("country-admins-list") ||
                    hasPermission("state-admins-list") ||
                    hasPermission("city-admins-list") ||
                    hasPermission("region-admins-list") ||
                    hasPermission("chapter-admins-list")) && (
                    <li>
                      <Link
                        className={
                          adminsRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/admins"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Admins</div>
                      </Link>
                    </li>
                  )}
                  {hasPermission("user-roles-list") && (
                    <li>
                      <Link
                        className={
                          userRoleRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/user-roles"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">User Roles</div>
                      </Link>
                    </li>
                  )}
                  {hasPermission("business-category-list") && (
                    <li>
                      <Link
                        className={
                          categoryRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/category"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Business Category</div>
                      </Link>
                    </li>
                  )}
                  {hasPermission("business-sub-category-list") && (
                    <li>
                      <Link
                        className={
                          businessSubCategoryRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/business-sub-category"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Business Sub Category</div>
                      </Link>
                    </li>
                  )}
                  {hasPermission("income-category-list") && (
                    <li>
                      <Link
                        className={
                          incomeCategoryRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/income-category"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Income Category</div>
                      </Link>
                    </li>
                  )}
                  {hasPermission("expense-category-list") && (
                    <li>
                      <Link
                        className={
                          expenseCategoryRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/expense-category"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Expense Category</div>
                      </Link>
                    </li>
                  )}
                  {hasPermission("posts-category-list") && (
                    <li>
                      <Link
                        className={
                          postsCategoryRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/posts-category"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Leads Category</div>
                      </Link>
                    </li>
                  )}
                  {hasPermission("sponsors-category-list") && (
                    <li>
                      <Link
                        className={
                          sponsorsCategoryRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/sponsors-category"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Sponsors Category</div>
                      </Link>
                    </li>
                  )}

                  {hasPermission("blood-groups-list") && (
                    <li>
                      <Link
                        className={
                          bloodgroupRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/blood-groups"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Blood Groups</div>
                      </Link>
                    </li>
                  )}
                  {/* Client: Crowns menu paused for now
                  {hasPermission("crowns-list") && (
                    <li>
                      <Link
                        className={
                          crownRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/crowns"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Crowns</div>
                      </Link>
                    </li>
                  )}
                  */}
                  {/* {hasPermission("timers-list") && (
                    <li>
                      <Link
                        className={
                          timerRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/timers"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Timers</div>
                      </Link>
                    </li>
                  )}
                  {hasPermission("timer-access-list") && (
                    <li>
                      <Link
                        className={
                          timerAccessRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/timer-access"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Timer Access</div>
                      </Link>
                    </li>
                  )} */}
                  {hasPermission("chapter-finance-access-list") && (
                    <li>
                      <Link
                        className={
                          chapterFinanceAccessRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/chapter-finance-access"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Circle Finance Access</div>
                      </Link>
                    </li>
                  )}
                  {hasPermission("currency-master-list") && (
                    <li>
                      <Link
                        className={
                          currencyMasterRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/currency"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Currency</div>
                      </Link>
                    </li>
                  )}
                </ul>
              )}
            </li>
          )}

        {hasPermission("points-system-list") && (
          <li
            className={pointsSystemRoutes() ? "menu-item active" : "menu-item"}
          >
            <Link
              className="menu-link"
              to="/points-system"
              onClick={closeDrawer}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <div data-i18n="Points System">Points System</div>
            </Link>
          </li>
        )}

        {hasPermission("roles-list") && (
          <li className={roleRoutes() ? "menu-item active" : "menu-item"}>
            <Link className="menu-link" to="/roles" onClick={closeDrawer}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M8.5 11C10.7091 11 12.5 9.20914 12.5 7C12.5 4.79086 10.7091 3 8.5 3C6.29086 3 4.5 4.79086 4.5 7C4.5 9.20914 6.29086 11 8.5 11Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M17 11V11C18.1046 11 19 10.1046 19 9C19 7.89543 18.1046 7 17 7V7"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M23 21V19C23 17.9391 22.5786 16.9217 21.8284 16.1716C21.0783 15.4214 20.0609 15 19 15H17"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <div data-i18n="Analytics">Roles & Permissions</div>
            </Link>
          </li>
        )}

        {hasPermission("settings-list") && (
          <li className={settingsRoutes() ? "menu-item active" : "menu-item"}>
            <Link className="menu-link" to="/settings" onClick={closeDrawer}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3 3H7V7H3V3ZM17 3H21V7H17V3ZM3 17H7V21H3V17ZM17 17H21V21H17V17Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                />
                <path
                  d="M9 9H15V15H9V9Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                />
              </svg>
              <div data-i18n="Analytics">Attendance QR Code</div>
            </Link>
          </li>
        )}

        {/* {hasPermission("forum-settings-list") && (
          <li
            className={forumSettingsRoutes() ? "menu-item active" : "menu-item"}
          >
            <Link
              className="menu-link"
              to="/forum-settings"
              onClick={closeDrawer}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M19.4 15A1.65 1.65 0 0 0 19.73 16.82L20.09 17.18C20.4651 17.5552 20.6758 18.064 20.6758 18.5945C20.6758 19.125 20.4651 19.6338 20.09 20.009C19.7148 20.3842 19.206 20.5949 18.6755 20.5949C18.145 20.5949 17.6362 20.3842 17.261 20.009L16.9 19.65A1.65 1.65 0 0 0 15.08 19.32A1.65 1.65 0 0 0 14.1 20.84V21.35C14.1 21.8804 13.8893 22.3892 13.5141 22.7644C13.1389 23.1396 12.6301 23.3503 12.0996 23.3503C11.5692 23.3503 11.0603 23.1396 10.6851 22.7644C10.3099 22.3892 10.0992 21.8804 10.0992 21.35V20.84A1.65 1.65 0 0 0 9.11925 19.32A1.65 1.65 0 0 0 7.29925 19.65L6.93925 20.01C6.56403 20.3852 6.05521 20.5959 5.52475 20.5959C4.99429 20.5959 4.48547 20.3852 4.11025 20.01C3.73503 19.6348 3.52435 19.126 3.52435 18.5955C3.52435 18.065 3.73503 17.5562 4.11025 17.181L4.47025 16.82A1.65 1.65 0 0 0 4.80025 15A1.65 1.65 0 0 0 3.28025 14.02H2.77025C2.23982 14.02 1.73099 13.8093 1.35578 13.4341C0.980561 13.0589 0.769882 12.5501 0.769882 12.0196C0.769882 11.4891 0.980561 10.9803 1.35578 10.6051C1.73099 10.2299 2.23982 10.0192 2.77025 10.0192H3.28025A1.65 1.65 0 0 0 4.80025 9.03922A1.65 1.65 0 0 0 4.47025 7.21922L4.11025 6.85922C3.73503 6.484 3.52435 5.97518 3.52435 5.44472C3.52435 4.91426 3.73503 4.40544 4.11025 4.03022C4.48547 3.655 4.99429 3.44432 5.52475 3.44432C6.05521 3.44432 6.56403 3.655 6.93925 4.03022L7.30025 4.39022A1.65 1.65 0 0 0 9.12025 4.72022A1.65 1.65 0 0 0 10.1002 3.20022V2.69022C10.1002 2.15978 10.3109 1.65096 10.6861 1.27575C11.0613 0.900531 11.5702 0.68985 12.1006 0.68985C12.6311 0.68985 13.1399 0.900531 13.5151 1.27575C13.8903 1.65096 14.101 2.15978 14.101 2.69022V3.20022A1.65 1.65 0 0 0 15.081 4.72022A1.65 1.65 0 0 0 16.901 4.39022L17.261 4.03022C17.6362 3.655 18.145 3.44432 18.6755 3.44432C19.206 3.44432 19.7148 3.655 20.09 4.03022C20.4652 4.40544 20.6759 4.91426 20.6759 5.44472C20.6759 5.97518 20.4652 6.484 20.09 6.85922L19.73 7.21922A1.65 1.65 0 0 0 19.4 9.03922A1.65 1.65 0 0 0 20.92 10.0192H21.43C21.9604 10.0192 22.4693 10.2299 22.8445 10.6051C23.2197 10.9803 23.4304 11.4891 23.4304 12.0196C23.4304 12.5501 23.2197 13.0589 22.8445 13.4341C22.4693 13.8093 21.9604 14.02 21.43 14.02H20.92A1.65 1.65 0 0 0 19.4 15Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <div data-i18n="Analytics">Forum Settings</div>
            </Link>
          </li>
        )} */}
      </ul>
    </aside>
  );
};

export default Sidebar;
